import { alpha, createTheme } from "@mui/material/styles"
import type { ColorMode } from "./colorMode"

export function getAppTheme(mode: ColorMode) {
	const isDark = mode === "dark"

	// Токены бренда (тёмный UI + синие акценты)
	const brand = {
		blue: "#1f6feb",
		deepBlue: "#0b3d91",
		skyBlue: "#38bdf8",
		darkBg: "#111416",
		darkPaper: "#1a1f22",
		lightBg: "#f6f7f9",
		lightPaper: "#ffffff",
	}

	return createTheme({
		palette: {
			mode,
			primary: {
				main: brand.blue,
				dark: brand.deepBlue,
				contrastText: "#ffffff",
			},
			secondary: {
				main: brand.skyBlue,
				contrastText: "#ffffff",
			},
			success: {
				main: brand.blue,
				dark: brand.deepBlue,
				contrastText: "#ffffff",
			},
			background: {
				default: isDark ? brand.darkBg : brand.lightBg,
				paper: isDark ? brand.darkPaper : brand.lightPaper,
			},
			text: {
				primary: isDark ? "#e8edf0" : "#0f1316",
				secondary: isDark ? alpha("#e8edf0", 0.7) : alpha("#0f1316", 0.7),
			},
			divider: isDark ? alpha("#e8edf0", 0.12) : alpha("#0f1316", 0.12),
		},
		shape: { borderRadius: 14 },
		typography: {
			fontFamily: '"Montserrat", "Literata", "Tektur", "Arial", sans-serif',
			h4: { fontWeight: 800, letterSpacing: 0.2 },
			button: { fontWeight: 700, textTransform: "none" },
		},
		components: {
			MuiCssBaseline: {
				styleOverrides: {
					body: {
						backgroundColor: isDark ? brand.darkBg : brand.lightBg,
					},
				},
			},
			MuiPaper: {
				styleOverrides: {
					root: {
						backgroundImage: "none",
						border: `1px solid ${isDark ? alpha("#ffffff", 0.08) : alpha("#000000", 0.08)}`,
					},
				},
			},
			MuiCard: {
				styleOverrides: {
					root: {
						backgroundImage: "none",
						border: `1px solid ${isDark ? alpha("#ffffff", 0.08) : alpha("#000000", 0.08)}`,
					},
				},
			},
			MuiButton: {
				styleOverrides: {
					root: { borderRadius: 12, fontWeight: 700 },
					containedPrimary: {
						background: `linear-gradient(135deg, ${brand.deepBlue} 0%, ${brand.blue} 100%)`,
						boxShadow: `0 10px 30px ${alpha(brand.blue, 0.25)}`,
						"&:hover": {
							boxShadow: `0 12px 34px ${alpha(brand.blue, 0.32)}`,
							filter: "brightness(1.03)",
						},
					},
				},
			},
			MuiOutlinedInput: {
				styleOverrides: {
					root: {
						borderRadius: 12,
					},
				},
			},
		},
	})
}


